/* eslint-disable no-param-reassign */
/* eslint-disable dot-notation */
import {
  addProductToCart,
  decreaseCartProductQuantity,
  deleteProductFromCart,
  getCart,
  updateCart,
} from '../../http/cartAPI';
import { calculateTotalPrice } from '../../utils/func';
import { saveModalOrderAction } from '../modal/actions';
import {
  cartLoadingAction,
  cartTotalPriceAction,
  saveCartAction,
  saveLocalCartAction,
} from './actions';
import { getBottleCountAndPrice } from '../../utils/bottlePrice';

// Отримати всю корзину
export const getCartOperation = () => dispatch => {
  dispatch(cartLoadingAction(true));

  // Імітація отримання кошика з localStorage
  if (!localStorage.getItem('cart')) {
    localStorage.setItem('cart', JSON.stringify([]));
  }

  dispatch(cartLoadingAction(false));

  const localCart = JSON.parse(localStorage.getItem('cart'));
  if (localCart) {
    dispatch(saveLocalCartAction(localCart));
    dispatch(setCartTotalPriceOperation(localCart));
  }
};

// Зменшити кількість товару в кошику (сервер)
export const decreaseCartProductQuantityOperation = (admin, id) => dispatch => {
  decreaseCartProductQuantity(admin, id).then(res => {
    dispatch(saveCartAction(res.data));
  });
};

// Видалити товар з кошика (сервер)
export const deleteProductFromCartOperation = (admin, id, cart) => dispatch => {
  // deleteProductFromCart(admin, id).then(res => {
  //   if (cart.products.length === 1) {
  //     dispatch(saveCartAction(null));
  //     dispatch(saveModalOrderAction(false));
  //   } else {
  //     dispatch(saveCartAction(res.data));
  //   }
  // });
};

// Додати товар в кошик (сервер)
export const addProductToCartOperation = (admin, id) => dispatch => {
  addProductToCart(admin, id).then(res => {
    dispatch(saveCartAction(res.data));
  });
};

// Оновити кошик (сервер)
export const updateCartOperation = (admin, products) => dispatch => {
  // dispatch(cartLoadingAction(true));
  // updateCart(admin, products).then(res => {
  //   dispatch(saveCartAction(res.data));
  //   dispatch(cartLoadingAction(false));
  //   dispatch(setCartTotalPriceOperation(res.data));
  // });
};

// 🔥 Операція для зміни локального кошика
// додано третій параметр payload (опціональний)
export const changeLocalCartOperation = (id, method, payload) => dispatch => {
  let localCart = JSON.parse(localStorage.getItem('cart')) || [];

  let newLocalCart = localCart.map(item => {
    if (item?.product._id !== id) {
      return item;
    }

    // Логіка для розпиву — оновлення мл + пляшечок
    if (method === 'updateBottling' && item.bottling) {
      const newQty =
        (payload && typeof payload.cartQuantity === 'number'
          ? payload.cartQuantity
          : item.cartQuantity) || 0;

      // якщо не передали готовий bottleCost — перерахуємо тут
      const newBottleCost =
        (payload && payload.bottleCost) || getBottleCountAndPrice(newQty);

      return {
        ...item,
        cartQuantity: newQty,
        bottleCost: newBottleCost,
      };
    }

    // Стандартна логіка для звичайних товарів
    if (method === 'decrease') {
      item.cartQuantity = Math.max(item.cartQuantity - 1, 0);
    } else if (method === 'add') {
      item.cartQuantity += 1;
    } else if (method === 'delete') {
      return null;
    }

    return item;
  });

  // Видаляємо null та позиції з 0
  newLocalCart = newLocalCart.filter(el => el !== null && el.cartQuantity > 0);

  // Оновлюємо localStorage
  localStorage.setItem('cart', JSON.stringify(newLocalCart));

  // Оновлюємо загальну ціну
  const totalPrice = calculateTotalPrice({ products: newLocalCart });
  dispatch(cartTotalPriceAction(totalPrice));

  // Зберігаємо оновлений кошик в Redux
  dispatch(saveLocalCartAction(newLocalCart));
};

// Встановлення загальної ціни кошика
export const setCartTotalPriceOperation = products => dispatch => {
  const totalPrice = calculateTotalPrice(products);
  dispatch(cartTotalPriceAction(totalPrice));
};
